export const moduleName = 'webinar';